export default __webpack_public_path__ + "static/media/fad-squareswitch-off.4c3389a1.svg";